// The dynamic audience filter of a WhatsApp campaign (owner order
// 2026-09-29): who messaged us first, within a period, capped at the newest
// N. Form state <-> the { type: 'DynamicFilter', ... } audience entry the
// server stores, plus the sentence the review step and the card show.
export const DYNAMIC_TYPE = 'DynamicFilter';

export const PERIODS = ['all', '7', '30', '60', '90', 'custom'];

export const emptyDynamicFilter = () => ({
  enabled: false,
  entrySource: 'incoming_message',
  period: '30',
  since: '',
  until: '',
  limit: '',
});

const positiveInt = value => {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
};

// The query the preview endpoint and the campaign payload share; null when
// the filter is off or carries no condition at all.
export const dynamicFilterQuery = state => {
  if (!state?.enabled) return null;
  const query = {};
  if (state.entrySource && state.entrySource !== 'any')
    query.entry_source = state.entrySource;
  if (state.period === 'custom') {
    if (state.since) query.since = state.since;
    if (state.until) query.until = state.until;
  } else if (state.period && state.period !== 'all') {
    query.days = parseInt(state.period, 10);
  }
  const limit = positiveInt(state.limit);
  if (limit) query.limit = limit;
  return Object.keys(query).length ? query : null;
};

export const dynamicFilterEntry = state => {
  const query = dynamicFilterQuery(state);
  return query ? { type: DYNAMIC_TYPE, ...query } : null;
};

// Rebuild the form state from a stored campaign audience.
export const dynamicFilterFromAudience = audience => {
  const entry = (audience || []).find(item => item?.type === DYNAMIC_TYPE);
  const state = emptyDynamicFilter();
  if (!entry) return state;
  state.enabled = true;
  state.entrySource = entry.entry_source || 'any';
  if (entry.days) {
    state.period = PERIODS.includes(String(entry.days))
      ? String(entry.days)
      : 'custom';
    if (state.period === 'custom') {
      const since = new Date(Date.now() - entry.days * 86400000);
      state.since = since.toISOString().slice(0, 10);
    }
  } else if (entry.since || entry.until) {
    state.period = 'custom';
    state.since = entry.since || '';
    state.until = entry.until || '';
  } else {
    state.period = 'all';
  }
  state.limit = entry.limit ? String(entry.limit) : '';
  return state;
};

// One line for the review step: «من راسلنا أولاً · آخر 30 يوماً · بحد أقصى 100».
export const dynamicFilterSummary = (state, tr) => {
  const query = dynamicFilterQuery(state);
  if (!query) return '';
  const parts = [];
  parts.push(tr(query.entry_source ? 'SUMMARY.INCOMING' : 'SUMMARY.ANY'));
  if (query.days) parts.push(tr('SUMMARY.DAYS', { count: query.days }));
  else if (query.since && query.until)
    parts.push(tr('SUMMARY.RANGE', { since: query.since, until: query.until }));
  else if (query.since) parts.push(tr('SUMMARY.SINCE', { since: query.since }));
  else if (query.until) parts.push(tr('SUMMARY.UNTIL', { until: query.until }));
  if (query.limit) parts.push(tr('SUMMARY.LIMIT', { count: query.limit }));
  return parts.join(' · ');
};
